<template lang="pug">
main.k-main( role='main' )
  slot( name='title' :title='title' )
    h1.title( v-html='title' )
  slot
</template>

<script lang="js">

export default {
  name: 'MainBlock',
  mixins: [],
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
@import "@/scss/breakpoint";

.k-main {
  transform: translateZ(0);
  z-index: 2;
  @include for-mobile {
    margin-bottom: 0;
  }
}
</style>
